import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";
import { Skeleton } from "@shortsworks/ui";

export const WidgetSettingsSchema: FormFieldSchema[] = [];
